import React from 'react';
import { render } from 'react-dom';
import { browserHistory, Router } from 'react-router';
import { syncHistoryWithStore } from 'react-router-redux'
import ApolloClient, { createNetworkInterface } from 'apollo-client';
import { ApolloProvider } from 'react-apollo';
import DevTools from './containers/DevTools';
import configureStore from './store/configure';
import routes from './routes';

const isDevelopment = process.env.NODE_ENV === 'development';

// Initialize the GraphQL client
const graphqlClient = new ApolloClient({
	networkInterface: createNetworkInterface({
		uri: '/graphql',
		opts: {
			credentials: 'same-origin',
		},
	}),
	dataIdFromObject: node => node.id,
});

// Configure the Redux store
const reduxStore = configureStore(graphqlClient);

// Set up the history router
const history = syncHistoryWithStore(browserHistory, reduxStore, {
	adjustUrlOnReplay: true
});

render(
	<ApolloProvider store={ reduxStore } client={ graphqlClient }>
		<div className="full-height">
			<Router history={ history }>
				{ routes }
			</Router>
			<If condition={ isDevelopment }>
				<DevTools />
			</If>
		</div>
	</ApolloProvider>,
	document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/assets/js/index.js